module.exports = {"unspecified":"Unspecified","horde":"Horde","alliance":"Alliance"};